import { useState, useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { svc_getAuth0User, svc_sendVerificationEmail } from '../../services/user.service';
import LoadingSpinner from '../ui/LoadingSpinner';
import { UserContext } from '../../contexts/user-context'

const UserProfileChecker = () => {
    const { getAccessTokenSilently, user } = useAuth0();
    const { emailVerified, setEmailVerified } = useContext(UserContext);
    const [isFetching, setIsFetching] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    const handleCheckClick = async () => {
        setIsFetching(true);
        fetchUserProfile();
    }

    const fetchUserProfile = async () => {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await svc_getAuth0User(accessToken, user.sub);

        if (error) {
            console.error("Error getting user profile: ", error);
            return;
        }

        const { email_verified } = data;

        setEmailVerified(email_verified);
        setIsFetching(false);
    };

    const handleSendVerificationEmail = async () => {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await svc_sendVerificationEmail(accessToken, user.sub);

        if (error) {
            console.error("Error sending verification email: ", error);
            return;
        }

        setEmailSent(true);
    }

    return (
        <div>
            <button
                className="button button-slim button-blue spc-m-b-1"
                onClick={handleCheckClick}
            >
                Check Email Verification Status
            </button>

            {isFetching && <LoadingSpinner />}

            {!isFetching && (
                emailVerified ? (
                    <p>Email is verified</p>
                ) : (
                    <p style={{fontStyle: 'italic', color: 'red'}}>Email is not verified</p>
                )
            )}

            {
            /* Resend verification email */
            !emailVerified && (
                <div>
                    <hr />
                    <p>
                        Didn't receive a verification email? Click the button below and check your inbox. (It may take a few minutes to arrive.)
                    </p>
                    {emailSent ? (
                        <p style={{fontStyle: 'italic', color: 'green'}}>Verification email sent</p>
                    ) : (
                        <button
                            className="button button-slim button-blue"
                            onClick={handleSendVerificationEmail}
                        >
                            Resend Verification Email
                        </button>
                    )}
                </div>
            )
            }


        </div>
    );
    };

    export default UserProfileChecker;